import React, { forwardRef } from 'react';
import DatePicker from 'react-datepicker';
import { useController } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDay } from '@fortawesome/pro-solid-svg-icons';
import 'react-datepicker/dist/react-datepicker.css';
import './date.css';

const CustomInput = forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>((props, ref) => {
  return (
    <label>
      <input {...props} ref={ref} />
      <FontAwesomeIcon icon={faCalendarDay} />
    </label>
  );
});

export interface DatePickerComponentProps {
  name: string;
  disabled?: boolean;
  minDate?: Date;
  maxDate?: Date;
  readonly?: boolean;
}

export const DateInput = ({
  name,
  disabled,
  minDate,
  maxDate,
}: DatePickerComponentProps) => {
  const refCustomInput = React.useRef(null);
  const {
    field: { value, onBlur, onChange },
  } = useController({ name, shouldUnregister: false });

  return (
    <div className="react-datepicker-container">
      <DatePicker
        name={name}
        disabled={disabled}
        locale="lv-LV"
        dateFormat="dd.MM.yyyy"
        selected={value && new window.Date(value.toString())}
        popperPlacement="top"
        popperProps={{ strategy: 'fixed' }}
        onChange={(date, event) => {
          const dateObject = date ? new window.Date(date.toString()) : null;
          onChange(
            dateObject
              ? new window.Date(
                  window.Date.UTC(
                    dateObject.getFullYear(),
                    dateObject.getMonth(),
                    dateObject.getDate()
                  )
                )
              : null,
            event
          );
        }}
        onBlur={onBlur}
        customInput={<CustomInput ref={refCustomInput} />}
        autoComplete="off"
        minDate={minDate}
        maxDate={maxDate}
      />
    </div>
  );
};
